<template>
  <div>
    <div class="filterRow">
      <md-field md-clearable>
        <md-input
          v-model="skuFilter"
          placeholder="Search SKU"
        />
      </md-field>

      <md-field>
        <label for="name-select">Name</label>
        <md-select
          id="name-select"
          v-model="nameFilter"
          name="name"
        >
          <md-option value="">
            All
          </md-option>
          <md-option
            v-for="i in nameFilterOptions"
            :key="i"
            :value="i"
          >
            {{ i }}
          </md-option>
        </md-select>
      </md-field>

      <md-field>
        <label for="currency-select">Currency</label>
        <md-select
          id="currency-select"
          v-model="currencyFilter"
          name="name"
        >
          <md-option value="">
            All
          </md-option>
          <md-option
            v-for="i in currencyFilterOptions"
            :key="i"
            :value="i"
          >
            {{ i }}
          </md-option>
        </md-select>
      </md-field>

      <md-checkbox
        v-model="hideDisabled"
        class="top-padded-item"
      >
        Only enabled
      </md-checkbox>
    </div>

    <md-progress-bar
      v-if="loading"
      md-mode="query"
    />
    <v-client-table
      v-else
      ref="table"
      :data="products"
      :columns="table.columns"
      :options="table.options"
      class="table"
    >
      <template #enabled="props">
        <md-checkbox
          v-model="props.row['enabled']"
          disabled
        />
      </template>

      <template #id="props">
        <router-link :to="{ name: 'Edit product v.2', params: { id: props.row.id } }">
          {{ props.row.id }}
        </router-link>
      </template>

      <template #sku="props">
        {{ props.row.sku }}
      </template>
      <template #name="props">
        {{ props.row.name }}
      </template>
      <template #final_price="props">
        {{ beautifyPrice(props.row) }}
      </template>
      <template #currency="props">
        {{ props.row.currency }}
      </template>

      <template #actions="props">
        <router-link :to="{ name: 'Clone product', params: { id: props.row.id } }">
          <md-icon>content_copy</md-icon>
        </router-link>
      </template>
      <!--            <template v-slot:version_filter_pattern="props">{{ props.row.version_filter_pattern }}</template>-->
    </v-client-table>
  </div>
</template>

<script>
    import {Event} from "vue-tables-2-premium";

    export default {
        name: "AppTable",
        props: {
            tableHeaderColor: {
                type: String,
                default: ""
            },
            appId: {
                type: String,
                default: "",
                required: true
            }
        },
        data() {
            return {
                loading: true,
                products: [],

                table: {
                    columns: [
                        "enabled", "id", "sku", "name", "final_price", "currency", "actions"
                        // 'version_filter_pattern'
                    ],
                    options: {
                        perPage: 100,
                        filterable: true, // might not be needed
                        sortable: ["enabled", "sku", "name", "final_price", "currency"],
                        customFilters: [
                            {
                                name: "enabled",
                                callback(row, hideDisabled) {
                                    if (hideDisabled) {
                                        return row.enabled;
                                    }
                                    return true;
                                }
                            },
                            {
                                name: "name",
                                callback(row, nameFilter) {
                                    if (!nameFilter) {
                                        return true;
                                    }
                                   return row.name === nameFilter;
                                }
                            },
                            {
                                name: "currency",
                                callback(row, currencyFilter) {
                                    if (!currencyFilter) {
                                        return true;
                                    }
                                    return row.currency === currencyFilter;
                                }
                            },
                            {
                                name: "sku",
                                callback(row, skuFilter) {
                                    if (!skuFilter) {
                                        return true;
                                    }
                                    return row.sku.includes(skuFilter);
                                }
                            }
                        ]
                    },
                },

                // table filter values
                hideDisabled: false,

                nameFilterOptions: [],
                nameFilter: "",

                currencyFilterOptions: [],
                currencyFilter: "",

                skuFilter: ""
            };
        },
        watch: {
            hideDisabled (newValue) {
              Event.$emit("vue-tables.filter::enabled", newValue);
            },
            nameFilter (newValue) {
              Event.$emit("vue-tables.filter::name", newValue);
            },
            currencyFilter (newValue) {
                Event.$emit("vue-tables.filter::currency", newValue);
            },
            skuFilter (newValue) {
                Event.$emit("vue-tables.filter::sku", newValue);
            }
        },
        mounted() {
            this.fetchProducts();
        },
        methods: {
            fetchProducts() {
                this.loading = true;
                this.$http.get(`/v1/admin/store/apps/${this.$props.appId}/products`).then(result => {
                    this.products = result.data.products.map(p => ({...p, amount: Number.parseInt(p.amount) }));

                    this.nameFilterOptions = Array.from(new Set(result.data.products.map(p => p.name)));
                    this.currencyFilterOptions = Array.from(new Set(result.data.products.map(p => p.currency)));

                    this.loading = false;
                }, err => {
                    console.error(err);
                });
            },
            beautifyPrice(product) {
                const amount = product.data.total_order_amount.amount;
                return Number.parseFloat(`${amount.slice(0, amount.length - 2) || "0"}.${amount.slice(amount.length - 2)}`);
            }
        }
    };
</script>

<style lang="scss">
    .filterRow {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      grid-column-gap: 32px;
    }

    .table {
        text-align: center;

        .VueTables__row:nth-child(2n+1) {
          background: rgba(#000, .04);
        }
    }
</style>
